export function formatTemperature(rawValue: number) {
  return Number(rawValue).toFixed(0).replace('-0', '0')
}
